<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <form role="form">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="mb-0">Nuevo jugador/a</h3>
                                    <hr>
                                </div>

                                <div class="col-md-4">
                                    <base-input
                                            label="Nombre"
                                            v-model="newPlayer.name"
                                            :valid="validations.name"
                                            @blur="checkText"
                                            placeholder="Nombre del jugador"
                                            input-classes="form-control-alternative"/>
                                </div>

                                <div class="col-md-4">
                                    <base-input
                                            label="Apellidos"
                                            v-model="newPlayer.surname"
                                            :valid="validations.surname"
                                            @blur="checkText"
                                            placeholder="Apellidos del jugador"
                                            input-classes="form-control-alternative"/>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="form-control-label" style="display: block; margin-bottom: 20px">Categoría</label>
                                        <div class="form-check form-check-inline">
                                            <base-radio name="Masculino" class="mb-3" v-model="newPlayer.gender">
                                                Masculino
                                            </base-radio>
                                        </div>
                                        <div class="form-check form-check-inline" style="margin-left: 10px">
                                            <base-radio name="Femenino" class="mb-3" v-model="newPlayer.gender">
                                                Femenino
                                            </base-radio>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <base-input
                                            label="Club de origen"
                                            v-model="newPlayer.clubOfOrigin"
                                            :valid="validations.clubOfOrigin"
                                            @blur="checkText"
                                            placeholder="Club de origen del jugador"
                                            input-classes="form-control-alternative"/>
                                </div>

                                <div class="col-md-4">
                                    <base-input
                                            label="Centro de estudios"
                                            v-model="newPlayer.studyCentre"
                                            :valid="validations.studyCentre"
                                            @blur="checkText"
                                            placeholder="Centro de estudios del jugador"
                                            input-classes="form-control-alternative"/>
                                </div>

                                <div class="col-md-4">
                                    <label class="form-control-label" style="display: block; margin-bottom: 10px">
                                        Fecha de nacimiento
                                    </label>
                                    <base-input addon-left-icon="ni ni-calendar-grid-58"
                                                :valid="validations.dateOfBirthday"
                                                @blur="checkDate">
                                        <flat-picker slot-scope="{focus, blur}"
                                                     @on-open="focus"
                                                     @on-close="blur"
                                                     :config="configDate"
                                                     class="form-control datepicker"
                                                     v-model="newPlayer.dateOfBirthday">
                                        </flat-picker>
                                    </base-input>
                                </div>

                                <div class="col-md-12">
                                    <label class="form-control-label" style="display: block; margin-bottom: 10px">
                                        Notas / Observaciones
                                    </label>
                                    <textarea class="form-control" id="exampleFormControlTextarea1"
                                              v-model="newPlayer.notes" rows="3"
                                              placeholder="Notas u observaciones del jugador"
                                              style="margin-bottom: 1.5rem;"></textarea>
                                </div>

                                <div class="col-md-12">
                                    <button class="btn btn-primary" @click.prevent="crearJugador"
                                            :disabled="disabledBotonCrearJugador  == 1 ? true : false">
                                        <i class="fa fa-check-circle"></i>
                                        {{textBotonCrearJugador}}
                                    </button>
                                    <button class="btn btn-warning" @click.prevent="$router.push({path:'/dashboard'})">
                                        <i class="fa fa-times-circle"></i>
                                        Cancelar
                                    </button>

                                    <div class="text-danger" v-if="textoError">
                                        <strong>{{textoError}}</strong>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import swal from 'sweetalert2'
    import flatPicker from "vue-flatpickr-component";
    import {Spanish} from 'flatpickr/dist/l10n/es'
    import "flatpickr/dist/flatpickr.css";

    export default {
        components: {flatPicker},
        data() {
            return {
                textoError: "",
                textBotonCrearJugador: "Guardar",
                disabledBotonCrearJugador: 0,
                newPlayer: {
                    name: "",
                    surname: "",
                    gender: "Masculino",
                    clubOfOrigin: "",
                    studyCentre: "",
                    dateOfBirthday: "today",
                    notes: ""
                },
                validations: {
                    name: 0,
                    surname: 0,
                    gender: 0,
                    clubOfOrigin: 0,
                    studyCentre: 0,
                    dateOfBirthday: 0
                },
                configDate: {
                    allowInput: false,
                    altFormat: 'd-m-Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    locale: Spanish
                },

            };
        },
        methods: {
            crearJugador() {
                if (this.newPlayer.gender == "Masculino") {
                    this.textBotonCrearJugador = "Guardando jugador...";
                } else {
                    this.textBotonCrearJugador = "Guardando jugadora...";
                }
                this.disabledBotonCrearJugador = 1;
                this.textoError = "";
                var errors = false;

                if (this.validations.name !== true) {
                    this.textoError = "Revise los campos marcados antes de continuar";
                    this.validations.name = false;
                    errors = true;
                }

                if (this.validations.surname !== true) {
                    this.textoError = "Revise los campos marcados antes de continuar";
                    this.validations.surname = false;
                    errors = true;
                }

                if (this.validations.clubOfOrigin !== true) {
                    this.textoError = "Revise los campos marcados antes de continuar";
                    this.validations.clubOfOrigin = false;
                    errors = true;
                }

                if (this.validations.studyCentre !== true) {
                    this.textoError = "Revise los campos marcados antes de continuar";
                    this.validations.studyCentre = false;
                    errors = true;
                }

                if (this.newPlayer.dateOfBirthday === "today") {
                    this.textoError = "Revise los campos marcados antes de continuar";
                    this.validations.dateOfBirthday = false;
                    errors = true;
                }

                if (!errors) {

                    let vm = this;
                    axios.post(this.$store.getters.apiUrl + 'players', {
                        newPlayer: this.newPlayer,
                        jwt: this.$store.getters.jwt
                    }).then(response => {
                        if (response.data.response) {
                            this.$router.push({path: '/dashboard'});
                        } else {
                            this.textBotonCrearJugador = "Guardar";
                            this.disabledBotonCrearJugador = 0;
                            swal({
                                title: 'Atención',
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                        }
                    }).catch(e => {
                        this.textBotonCrearJugador = "Guardar";
                        this.disabledBotonCrearJugador = 0;
                        swal({
                            title: 'Atención',
                            text: e,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    });
                } else {
                    this.textBotonCrearJugador = "Guardar";
                    this.disabledBotonCrearJugador = 0;
                }


            },
            checkText() {
                let name = this.newPlayer.name;
                let surname = this.newPlayer.surname;
                let clubOfOrigin = this.newPlayer.clubOfOrigin;
                let studyCentre = this.newPlayer.studyCentre;

                if (name === "") {
                    this.validations.name = 0;
                } else {
                    this.validations.name = true;
                }

                if (surname === "") {
                    this.validations.surname = 0;
                } else {
                    this.validations.surname = true;
                }

                if (clubOfOrigin === "") {
                    this.validations.clubOfOrigin = 0;
                } else {
                    this.validations.clubOfOrigin = true;
                }

                if (studyCentre === "") {
                    this.validations.studyCentre = 0;
                } else {
                    this.validations.studyCentre = true;
                }
            },
            checkDate() {
                if (this.newPlayer.dateOfBirthday === "") {
                    this.newPlayer.dateOfBirthday = new Date();
                } else {
                    this.validations.dateOfBirthday = true;
                }
            },

        }

    };
</script>
<style scoped>

    .container-fluid {
        margin-top: 39px;
    }

    .card {
        padding: 20px;
        background-color: #f7fafc !important;
        box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
        border: 1px solid rgba(0, 0, 0, .05);
        border-radius: .375rem;
    }


</style>
